import axios from 'axios';
import { apolloClient } from '@signing-page/apollo';
import { commentsQuery } from '@signing-page/api/chat/graphql/chat.queries';
import { IComment } from '@signing-page/chat/types/comment';
import { EFetchPolicy } from '@lib-shared/api/types/enums/fetch-policy';

export class ChatService {
  static async getComments(): Promise<IComment[]> {
    const {
      data: { comments },
    } = await apolloClient.query({
      query: commentsQuery,
      fetchPolicy: EFetchPolicy.NetworkOnly,
    });
    return comments;
  }

  static async addComment(
    documentId: string,
    recipientId: string,
    authId: string,
    commentText: string
  ): Promise<boolean> {
    const body: FormData = new FormData();
    body.append('comment_text', commentText);

    const response = await axios.post(`/view/${documentId}/${recipientId}/${authId}/comment`, body);
    return !!response;
  }

  static async autoComment(
    documentId: string,
    recipientId: string,
    authId: string
  ): Promise<boolean> {
    const {
      data: { status },
    } = await axios.post(`/view/${documentId}/${recipientId}/${authId}/autocomment`);
    return status;
  }
}
